import {Component, Input, OnInit} from '@angular/core';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {DocumentModel} from '../../models/document.model';
import {AlertController, ModalController} from '@ionic/angular';
import {ProductMultiSelectComponent} from '../../modals/product-multi-select/product-multi-select.component';
import { GeneralService } from 'src/app/services/general.service';
import { ScanBarcodeService } from 'src/app/services/scan-barcode.service';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import { BarcodeOptions } from 'src/app/definitions/barcode-options';
import { FindProductPriceService } from 'src/app/services/find-product-price.service';

@Component({
    selector: 'spares-fuel-ws',
    templateUrl: './spares-fuel-ws.component.html',
    styleUrls: ['./spares-fuel-ws.component.scss'],
})
export class SparesFuelWsComponent implements OnInit {
    @Input() document: DocumentModel;
    @Input() title: string;
    detailLines: DetaillineDTOModel[];
    icon: string;

    constructor(private alertController: AlertController,
                public modalController: ModalController,
                private scanBarcodeService: ScanBarcodeService,
                private generalService: GeneralService,
                private barcodeScanner: BarcodeScanner,
                private barcodeOptions: BarcodeOptions,
                private findProductPriceService: FindProductPriceService) {
    }

    ngOnInit() {
        console.log(this.title.toLowerCase());
        this.icon = this.getIcon();
        this.updateDetailLines();
    }

    updateDetailLines() {
        this.detailLines = this.document.detailLines.filter(line => {
            if (this.title.toLowerCase() === 'parts') {
                console.log(line.fuelProductType);
                return !line.fuelProductType;
            }
            if (this.title.toLowerCase() === 'fuel') {
                console.log(line.fuelProductType);
                return line.fuelProductType;
            }
        });
    }

    async productSelect() {
        const modal = await this.modalController.create({
            component: ProductMultiSelectComponent,
            cssClass: 'modal-fullscreen',
            backdropDismiss: false,
            componentProps: {
                document: this.document,
                behaviour: this.title
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            this.updateDetailLines();
        });
        return await modal.present();
    }

    async editItemQty(item: DetaillineDTOModel) {
        const alert = await this.alertController.create({
            header: 'Edit Product',
            message: 'Please adjust the quantity.',
            backdropDismiss: false,
            inputs: [
                {
                    name: 'itemQty',
                    type: 'number',
                    value: item.qty,
                    placeholder: 'Enter new Qty'
                },
                {
                    name: 'itemDescription',
                    type: 'text',
                    value: item.comment,
                    placeholder: 'Enter new Description'
                },
                {
                    name: 'itemPrice',
                    type: 'number',
                    value: item.total,
                    placeholder: 'Enter new Price'
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                    }
                },
                {
                    text: 'Ok',
                    handler: data => {
                        item.qty = data.itemQty;
                        item.total = data.itemPrice;
                        item.comment = data.itemDescription;
                    }
                }
            ]
        });

        await alert.present();
    }

    deleteLine(item: DetaillineDTOModel) {
        // this.document.detailLines.splice(i, 1);
        console.log(this.document.detailLines.indexOf(item));
        this.detailLines.splice(this.detailLines.indexOf(item), 1);
        this.document.detailLines.splice(this.document.detailLines.indexOf(item), 1);
    }

    private getIcon() {
        switch (this.title.toLowerCase()) {
            case 'fuel':
                return 'flame';
            case 'parts':
                return 'cart';
            default:
                return 'cart';
        }
    }


    async scanItem() {
        this.barcodeScanner.scan(this.barcodeOptions.options).then(barcode => {

            console.log(barcode.text);
            
            // check if we scanned an EAN13 barcode , but are 
            // barcode length is 12 digits , it means its stripped a leading 
            // zero , we must add it back in


            this.handleScanResult(barcode.text);
        }).catch(err => {
            console.log(err);
            //this.handleScanResult('000000000475');

        });
    }

    async handleScanResult(barcode) {
        console.log('Scan Result');
        console.log(barcode);
        var stockLine = this.scanBarcodeService.findProductWithBarcode(barcode) as DetaillineDTOModel;

        if (stockLine) {
            this.confirmEquipment(JSON.parse(JSON.stringify(stockLine)));
        } else {
            stockLine = this.scanBarcodeService.findProductWithBarcode( '0' + barcode ) as DetaillineDTOModel;

            /*console.log( stockLine.length );*/
            if(stockLine && ( barcode.length + 1 )  > 10 ){ // we added a '0' 
                this.confirmEquipment(JSON.parse(JSON.stringify(stockLine)));
            }else{
                await this.generalService.createToast('No match with barcode: ' + barcode);
                if (barcode) {
                    this.scanItem();
                }
            }
            
        }
    }

    async confirmEquipment(product) {
        const alert = await this.alertController.create({
            header: 'Equipment found: ' + product.description,
            message: 'Please inform quantity.',
            backdropDismiss: false,
            inputs: [
                {
                    name: 'qty',
                    type: 'number',
                    placeholder: 'Quantity'
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                        this.scanItem();
                    }
                }, {
                    text: 'Yes',
                    handler: data => {
                        console.log(data.qty);
                        product.qty = data.qty;
                        this.insertLineIntoDocument(product);
                        this.updateDetailLines();
                        this.scanItem();
                    }
                }
            ]
        });
        await alert.present();
    }

    async insertLineIntoDocument(detail: DetaillineDTOModel) {
                detail.comment = detail.description;
                detail.qty = (detail.qty && detail.qty > 0) ? detail.qty : 1;
                await this.findProductPriceService.findFinalPriceAndDiscount( detail , this.document);
                this.document.detailLines.push( detail );
                this.detailLines.push( detail );
    }

}
